import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation createCallsheetAnalysis($input: CallsheetAnalysisInput!) {
    createCallsheetAnalysis(input: $input) {
      ...callsheetAnalysisDetail
    }
  }
  ${fragments.callsheetAnalysisDetail}
  ${fragments.kgraphDetail}
  ${fragments.personDetail}
  ${fragments.companyDetail}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.contactDetail}
  ${fragments.profession}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
  ${fragments.personArtworks}
  ${fragments.artworkDetails}
  ${fragments.artworkToArtifacts}
`;
